import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  delete_affiliation_request,
  get_my_affiliations,
} from "../../../DAL/clientTypes/ClientTpes";
import { enqueueSnackbar } from "notistack";
import CircularLoader from "../../../components/loader/CircularLoader";
import { useIds } from "../../../hook/AdminContext";
import CustomMUITable from "../../../components/customtable/CustomMuiTable";
import moment from "moment";
import CustomConfirmation from "../../../components/popUp/CustomConfirmation";
import RecordNoImage from "../../../components/recordNotFound/RecordNoImage";
import ClientHoverImageCard from "../../clientTypes/components/ClientHoverImageCard";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CircularProgress, Tooltip } from "@mui/material";
import GeneralMUIDialog from "../../../components/GeneralMUIDialog/GeneralMUIDialog";
import AddAffiliate from "./AddAffiliate";
import { useNavigate } from "react-router-dom";
import AppliedFilters from "../../../components/AppliedFilters/AppliedFilters";
import ResponseFieldFilter from "../../../components/ResponseFieldFilter/ResponseFieldFilter";
import { Funnel } from "lucide-react";
import AffiliateCard from "../../clientTypes/components/AffiliateCard";

export default function MyAffiliates({
  isChanged,
  // handleClentDetails = () => {},
  isManagePage = false,
}) {
  const { userInfo, setBreadCrumb, setUpdateSentAffiliatesOnNotification } =
    useIds();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [affiliationList, setAffiliationList] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [targetAffiliation, setTargetAffiliation] = useState(null);
  const [openAddAffiliateModal, setOpenAddAffiliateModal] = useState(false);

  // filter states
  const [filterModal, setFilterModal] = useState(false);
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);

  const handleFilterData = () => {
    setFilterModal(false);
    setLoading(true);
    handleGetAffiliations();
  };

  // load more states and function
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          setPageNumber(pageNumber + 1);
          setIsLoadingMore(true);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleGetAffiliations = async () => {
    const resp = await get_my_affiliations(
      userInfo.profile_id,
      pageNumber,
      isManagePage ? 8 : 20,
      filterData?.response?.value || ""
    );
    if (resp.code === 200) {
      if (isLoadingMore && !isManagePage) {
        let newArray = affiliationList.concat(resp?.data?.sender || []);
        setAffiliationList(newArray);
      } else {
        setAffiliationList(resp.data.sender);
      }
      setAppliedFilterData(filterData);
      setTotalPages(resp.data.total_page);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
    setIsLoadingMore(false);
  };

  const handleAgreeDelete = async () => {
    const resp = await delete_affiliation_request(targetAffiliation._id);
    if (resp.code == 200) {
      setLoading(true);
      setAffiliationList((prev) =>
        prev.filter((client) => client._id !== targetAffiliation._id)
      );
      // handleGetAffiliations();
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setDeleteConfirmation(false);
  };
  const handleDeleteAffiliation = (obj) => {
    setTargetAffiliation(obj);
    setDeleteConfirmation(true);
  };

  const handleAddAffilates = () => {
    setOpenAddAffiliateModal(true);
  };

  const handleViewAll = () => {
    navigate("/profile/manage-affiliate/affiliate-sent");
  };

  useEffect(() => {
    handleGetAffiliations();
  }, [isChanged, isManagePage, pageNumber, filterChange]);

  const TABLE_HEAD = [
    { id: "action", label: "Action", type: "action" },
    { id: "number", label: "#", type: "number" },
    { id: "receiver_object", label: "Client", type: "client_profile" },
    {
      id: "response",
      label: "Response",
      className: "text-capitalize",
      type: "string_status",
      chipColor: (value) => {
        return value == "pending"
          ? "info"
          : value == "accepted"
          ? "success"
          : "error";
      },
    },
    {
      id: "created_at",
      label: "Created At",
      renderData: (row) => <span>{moment(row.createdAt).format("ll")}</span>,
    },
  ];

  const MENU_OPTIONS = [
    {
      label: "Delete Affiliation",
      icon: "ant-design:delete-twotone",
      handleClick: handleDeleteAffiliation,
    },
  ];

  useEffect(() => {
    if (isManagePage) return;
    setBreadCrumb([
      {
        name: `Profile`,
        path: `/profile`,
        active: false,
      },
      {
        name: `Manage Affiliate`,
        path: `/profile/manage-affiliate`,
        active: false,
      },
      {
        name: `Affiliations Sent`,
        path: `/profile/manage-affiliate/affiliate-sent`,
        active: false,
      },
    ]);
  }, [isManagePage]);

  const handleUpdateAffiliateOnNotification = (
    requestData,
    setList = setAffiliationList
  ) => {
    if (requestData.deleted_affiliate_id) {
      setList((prev) =>
        prev.filter((item) => item._id != requestData.deleted_affiliate_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === requestData._id ? { ...item, ...requestData } : item
      )
    );
  };

  const handleClentDetails = (item) => {
    navigate("/user/" + item?._id);
  };

  useEffect(() => {
    // Register the function
    setUpdateSentAffiliatesOnNotification(() => (data) => {
      handleUpdateAffiliateOnNotification(data, setAffiliationList);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateSentAffiliatesOnNotification(() => () => {});
    };
  }, [affiliationList]);

  if (loading) {
    <CircularLoader />;
  }
  return (
    <>
      {deleteConfirmation && (
        <CustomConfirmation
          openDelete={deleteConfirmation}
          setOpenDelete={setDeleteConfirmation}
          title={`Are you sure you want to delete affiliation with ${targetAffiliation?.receiver_object?.company_name}`}
          headerHeading={"Delete Affiliation"}
          handleAgree={handleAgreeDelete}
        />
      )}

      {openAddAffiliateModal && (
        <GeneralMUIDialog
          open={openAddAffiliateModal}
          setOpen={setOpenAddAffiliateModal}
          title={"Add Affiliate"}
          content={<AddAffiliate setIsChanged={handleGetAffiliations} />}
          cancelText={"Close"} // cancel button text
          maxWidth={"lg"}
          showActionButton={false}
        />
      )}

      {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          actionText="Filter"
          title="Filter"
          content={
            <ResponseFieldFilter
              inputs={filterData}
              setInputs={setFilterData}
              typesList={[
                {
                  value: "accepted",
                  title: "Accepted",
                },
                {
                  value: "pending",
                  title: "Pending",
                },
              ]}
            />
          }
          onSubmit={handleFilterData}
        />
      )}

      <div
        className={`container-fluid affiliation-sent ${
          isManagePage ? "mb-3" : "my-3"
        }`}
      >
        {isManagePage ? (
          <div className="d-flex justify-content-between align-items-end sub-heading-block">
            <h4>Affiliations Sent</h4>
            <div className="d-flex align-items-center">
              <button
                className="btn-outlined-sm tw-mb-3"
                onClick={() => handleViewAll()}
              >
                View All
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between align-items-start heading-main">
            <h3 className="mb-1">Affiliations Sent</h3>
            <div className="d-flex align-items-center tw-mb-3">
              <div
                className="me-2 pointer d-flex  align-items-center justify-content-center tw-rounded-md tw-border tw-border-solid tw-border-[#0000003b]"
                style={{
                  height: 38,
                  width: 38,
                }}
                onClick={() => setFilterModal(true)}
              >
                <Funnel className="tw-h-4 tw-w-4" />
              </div>

              <button
                className="btn-outlined-sm"
                onClick={() => handleAddAffilates()}
              >
                Add Affiliates
              </button>
            </div>
          </div>
        )}
        {/* <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          data={affiliationList}
          MENU_OPTIONS={MENU_OPTIONS}
        /> */}

        {appliedFilterData && (
          <div>
            <AppliedFilters
              filterData={appliedFilterData}
              setFilterData={setFilterData}
              onFilterChange={() => {
                setLoading(true);
                setFilterChange((prev) => !prev);
              }}
            />
          </div>
        )}

        {affiliationList.length > 0 ? (
          <>
            <div className="d-grid gap-3 grid-template">
              {(isManagePage
                ? affiliationList.slice(0, 8)
                : affiliationList
              ).map((obj) => (
                <AffiliateCard
                  client={obj.receiver_object}
                  handleNavigateDetails={(item) => {
                    handleClentDetails(item);
                  }}
                  chipValue={obj.response}
                  chipColor={
                    obj.response == "pending"
                      ? "info"
                      : obj.response == "accepted"
                      ? "success"
                      : "error"
                  }
                  showAdditionalButton={true}
                  additionButton={
                    <div className="d-flex justify-content-end pe-3 pt-2">
                      <Tooltip title="Delete Affiliation" placement="top">
                        <button
                          className="btn-white-bg-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteAffiliation(obj);
                          }}
                          disabled={obj[`deleteloading`]}
                        >
                          <Icon
                            icon={"mingcute:delete-2-line"}
                            fontSize={"16px"}
                            color="var(--portal-error-color)"
                          />
                        </button>
                      </Tooltip>
                    </div>
                  }
                />
              ))}
            </div>

            {!loading &&
              !isManagePage &&
              totalPages > 1 &&
              totalPages > pageNumber &&
              affiliationList.length > 0 && (
                <div className="col-12 text-center mt-3">
                  <div
                    ref={lastBookElementRef}
                    className="mt-3"
                    onClick={() => {
                      setPageNumber(pageNumber + 1);
                    }}
                    id="load-more-feed"
                  >
                    {isLoadingMore ? (
                      <CircularProgress size={15} />
                    ) : (
                      "Load More"
                    )}
                  </div>
                </div>
              )}
          </>
        ) : (
          <div className="mt-5">
            <RecordNoImage title={"No Affiliations Sent"} />{" "}
          </div>
        )}
      </div>
    </>
  );
}
